import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalShell } from '../modalsShared';

const RequestStatusModal = ({
  isOpen,
  request,
  onClose,
  onSubmit,
  isSubmitDisabled = false,
}) => {
  const [decision, setDecision] = useState('approved');
  const [remarks, setRemarks] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setDecision('approved');
    setRemarks('');
    setSubmitting(false);
  }, [isOpen, request?.scrn]);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (isSubmitDisabled) return;
    if (!onSubmit) {
      onClose();
      return;
    }
    setSubmitting(true);
    const success = await onSubmit(decision, remarks);
    setSubmitting(false);
    if (success === true) {
      setDecision('approved');
      setRemarks('');
    }
  };

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title="Update request status"
      size="small"
      modalClassName="request-history-submodal"
    >
      <form
        className="modal-form request-history-edit-form request-history-status-form"
        onSubmit={(event) => event.preventDefault()}
      >
        {(request?.project?.name || request?.projectName || request?.scrn) ? (
          <div className="request-history-project-meta">
            {(request?.project?.name || request?.projectName) ? (
              <div className="request-history-project-meta__item">
                <span className="request-history-project-meta__label">Project name</span>
                <span className="request-history-project-meta__value">
                  {request?.project?.name || request?.projectName}
                </span>
              </div>
            ) : null}
            {request?.scrn ? (
              <div className="request-history-project-meta__item request-history-project-meta__item--compact">
                <span className="request-history-project-meta__label">Request ID</span>
                <span className="request-history-project-meta__value">{request.scrn}</span>
              </div>
            ) : null}
          </div>
        ) : null}

        <div className="form-group">
          <label htmlFor="request-status-decision">Decision</label>
          <select
            id="request-status-decision"
            value={decision}
            onChange={(event) => setDecision(event.target.value)}
            disabled={isSubmitDisabled || submitting}
          >
            <option value="approved">Approve</option>
            <option value="rejected">Reject</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="request-status-remarks">Approvers remarks</label>
          <textarea
            id="request-status-remarks"
            rows="3"
            value={remarks}
            onChange={(event) => setRemarks(event.target.value)}
            placeholder="Add remarks"
            disabled={isSubmitDisabled || submitting}
          />
        </div>

        <div className="modal-actions">
          <button type="button" className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={handleSubmit}
            disabled={isSubmitDisabled || submitting}
          >
            {decision === 'approved' ? 'Approve' : 'Reject'}
          </button>
        </div>
      </form>
    </ModalShell>
  );
};

RequestStatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  request: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  isSubmitDisabled: PropTypes.bool,
};

export default RequestStatusModal;
